import i18n from "../../../../../../app/js/utils/i18n";
import { breakpoints } from '../../../../../../app/js/utils/responsive_utilities';

export const getData = () => {
  const kGrader = i18n.language == "en" ? "K" : i18n.t("grader.K").substring(0, 1).toUpperCase() + i18n.t("grader.K").substring(1);
  const firstGrader = i18n.t("grader.1st").substring(0, 1).toUpperCase() + i18n.t("grader.1st").substring(1);

  return [
    {
      title: `“Fun and well structured. My daughter feels like she is having real fun while learning”`,
      name: 'Abdelhalim',
      designation: `Parent, ${kGrader} & ${i18n.t("grader.5th")}`,
      image: 'https://cdn.splashmath.com/assets/casestudy/parents/abdelhalim-0f398c9393908f74f5e75c8d78f040dc8c2c32a7e750bca985686851067ab4d2.jpg',
      isCdnImage: true
    },
    {
      title: `“My son, who had a hard time reading, is able to sound out words better with just a month of playing SplashLearn”`,
      name: 'Robyn Meeker',
      designation: `Parent, ${firstGrader}`,
      image: 'https://cdn.splashmath.com/assets/casestudy/parents/robyn1-9f60fe6902fd770315bf55c55150e66b219fadeb18b6cf4d61e44ebb8877e751.jpg',
      isCdnImage: true
    },
    {
      title: `“Made ${i18n.t("math")} very fun and approachable for my kiddo“`,
      name: 'Glenndel Prochnow',
      designation: `Parent, ${kGrader}`,
      image: 'https://cdn.splashmath.com/assets/casestudy/parents/glenndel.png',
      isCdnImage: true
    }
  ]
}

export const sliderSettings = {
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  infinite: false,
  dots: false,
  cssEase: "ease",
  speed: 1500,
  centerPadding: "60px",
  lazyLoad: true,
  className: "slider-wrapper",
  variableWidth: true,
  adaptiveHeight: true,
  initialSlide: 1,
  responsive: [
    {
      breakpoint: breakpoints.xl,
      settings: {
        centerMode: true,
        centerPadding: '250px',
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        variableWidth: false,
        autoplay: true
      }
    },
    {
      breakpoint: breakpoints.lg,
      settings: {
        centerMode: true,
        centerPadding: '200px',
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        variableWidth: false,
        autoplay: true
      }
    },
    {
      breakpoint: breakpoints.md,
      settings: {
        centerMode: true,
        centerPadding: '150px',
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        variableWidth: false,
        autoplay: true
      }
    },
    {
      breakpoint: breakpoints.sm,
      settings: {
        centerMode: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        variableWidth: false,
        autoplay: true
      }
    }
  ]
}
